import styled from 'styled-components';
import { Text as TextBase } from 'components/Typography';
import { getThemeColor } from 'utils/styled';

export const Root = styled(TextBase).attrs({
  variant: 'adornment',
})`
  background-color: ${getThemeColor('danger')};
  border-radius: 4px;
  color: ${getThemeColor('white')};
  display: inline-block;
  font-weight: normal;
  letter-spacing: normal;
  margin-bottom: 0px;
  margin-top: 8px;
  padding: 5px 6px;
  text-transform: none;
  width: fit-content;
`;
